import React, { useState } from "react";
class Rating extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rating: -1,
    };
  }

  handleClick(i) {
    this.setState({ rating: i });
    this.props.handleRating(i)
  }
  render() {
    const stars = [...Array(this.props.totalStars)];
    return (
      <div className="starrating">
        {stars.map((s, i) => (
          <label
            key={i}
            onClick={this.handleClick.bind(this, i)}
            className={i <= this.state.rating ? "star active" : "star"}
          >
            <input type="radio" name="rate" />
            {/* {this.state.rating + 1}
            {this.props.questionRating} */}
          </label>
        ))}
      </div>
    );
  }
}
export default Rating;
